// Hot-listed live products. Update `availability` + `offer` fields anytime.
import { Flame, Package, Layers, Wheat, Trees, Cog, Shield } from "lucide-react";

export const HOT_PRODUCTS = [
  {
    id: "rice-straw-pellet",
    name: "Rice Straw Pellet",
    hi: "धान पराली पेलेट (8mm / 10mm)",
    icon: Wheat,
    price: "₹6,200 / Ton",
    availability: "Daily 100 T",
    offer: "Freight as per location",
    spec: "Size: 8 mm & 10 mm",
    tag: "HOT",
    image:
      "https://customer-assets.emergentagent.com/job_eco-trade-zone/artifacts/indw1eff_RICE%20HUSK%20PELLET.jpeg",
  },
  {
    id: "mustard-pellet",
    name: "Mustard Pellet",
    hi: "सरसों पेलेट (8mm / 10mm)",
    icon: Trees,
    price: "₹6,500 / Ton",
    availability: "Daily 100 T",
    offer: "Freight as per location",
    spec: "Size: 8 mm & 10 mm",
    tag: "HOT",
    image:
      "https://customer-assets.emergentagent.com/job_eco-trade-zone/artifacts/isw5ywe6_buyer%20seller.jpg",
  },
  {
    id: "mustard-briquette",
    name: "Mustard Briquette",
    hi: "सरसों ब्रिकेट (90mm)",
    icon: Layers,
    price: "₹6,100 / Ton",
    availability: "Daily 500 T",
    offer: "Bulk contract available",
    spec: "Diameter: 90 mm",
    tag: "LIVE",
    image:
      "https://customer-assets.emergentagent.com/job_eco-trade-zone/artifacts/2mowr8o8_MUSTARD%20BRIQUTE.webp",
  },
  {
    id: "tripal",
    name: "Tripal (Tarpaulin)",
    hi: "त्रिपाल — 300 माइक्रोन",
    icon: Shield,
    price: "Quote on request",
    availability: "Any size",
    offer: "Water · Rain · Weather proof",
    spec: "300 micron best quality",
    tag: "LIVE",
    image:
      "https://customer-assets.emergentagent.com/job_eco-trade-zone/artifacts/ww9zxp0i_TRIPAL%20IAMGES.webp",
  },
  {
    id: "pellet-burner",
    name: "Pellet Burner",
    hi: "पेलेट बर्नर",
    icon: Flame,
    price: "From ₹9,999 / pc",
    availability: "Rocket Home + CECP models",
    offer: "Replaces LPG — huge cost savings",
    spec: "Home & Commercial (hotels, catering, sweet shops, industrial)",
    tag: "HOT",
    image:
      "https://customer-assets.emergentagent.com/job_eco-trade-zone/artifacts/0qd5spr0_PELLET%20BURNER%20INDUSTRIAL.webp",
    long:
      "Pellet burners slash costs by replacing LPG gas with efficient biomass. Stable, natural flame for consistent high-quality heat. Models: Rocket Home (₹9,999/pc) and Cost-Effective Commercial Pellet Burner (CECP) for hotels, catering, sweet shops & industrial use.",
  },
  {
    id: "ring-die",
    name: "Ring Die (Pellet Machine)",
    hi: "रिंग डाई",
    icon: Cog,
    price: "Quote on request",
    availability: "On-time delivery",
    offer: "On-site maintenance service",
    spec: "For all standard pellet manufacturing machines",
    tag: "NEW",
    image:
      "https://customer-assets.emergentagent.com/job_eco-trade-zone/artifacts/vj1yukq0_RING%20DIE.jpg",
  },
];

export const PRODUCT_CATEGORIES = [
  { key: "ALL", en: "All Products", hi: "सभी" },
  { key: "HOT", en: "Hot Listed", hi: "हॉट" },
  { key: "LIVE", en: "Live Offers", hi: "लाइव" },
  { key: "NEW", en: "New Arrivals", hi: "नया" },
];
